module.exports = new __parcel__URL__("twitter.ee452e57.png").toString();